import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import {
  CheckExitFeedBackFormTypes,
  IncomingEmployeeSeparationForm,
  SeparationInitialStateTypes,
} from '../../../types/MyProfile/Separation/separationTypes'
import SeparationApi from '../../../middleware/api/MyProfile/Separation/SeparationApi'
import { ValidationError } from '../../../types/commonTypes'
import { RootState } from '../../../stateStore'

export const initialEmployeeSeparationData: IncomingEmployeeSeparationForm = {
  separationId: -1,
  relievingDate: '',
  resignationDate: '',
  employeeId: 2081,
  employeeName: '',
  separationComments: [],
  employeeComments: '',
  managerComments: null,
  withdrawComments: null,
  primaryReasonId: null,
  primaryReasonName: '',
  reasonComments: '',
  status: '',
  canberevoked: false,
  isRevoked: false,
  isprocessInitiated: null,
  adminCcCss: null,
  hrCcCss: null,
  managerCcCss: null,
  itCcCss: null,
  finanaceCcCss: null,
  showCommentsBox: false,
  showEditButton: false,
  certificateDTO: [],
  relievingLetterPath: '',
  managerName: null,
  exitFeedbackFormPath: '',
  separationExist: null,
  showManagerClearance: null,
  showTimeline: null,
  isPIP: null,
  pipAuditDTO: null,
  contractExists: null,
  contractStartDate: null,
  contractEndDate: null,
  personalEmailFlag: null,
  initiatedDate: null,
  empStatus: null,
  certificate: null,
  seperationComments: [],
}

const initialState: SeparationInitialStateTypes = {
  isLoading: ApiLoadingState.idle,
  error: null,
  employeeSeparationData: initialEmployeeSeparationData,
  checkExitFeedBackFormTypes: {} as CheckExitFeedBackFormTypes,
}

const getEmployeeSeparationFormThunk = createAsyncThunk(
  'Separation/getEmployeeSeparationFormThunk',
  async (employeeId: number, thunkApi) => {
    try {
      return await SeparationApi.getEmployeeSeparationForm(employeeId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status)
    }
  },
)

const checkExitFeedBackForm = createAsyncThunk(
  'Separation/checkExitFeedBackForm',
  async (separationId: number, thunkApi) => {
    try {
      return await SeparationApi.checkExitFeedBackForm(separationId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status)
    }
  },
)

const separationSlice = createSlice({
  name: 'Separation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEmployeeSeparationFormThunk.pending, (state) => {
      state.isLoading = ApiLoadingState.loading
    })
    builder.addCase(
      getEmployeeSeparationFormThunk.fulfilled,
      (state, action) => {
        state.employeeSeparationData = action.payload
        state.isLoading = ApiLoadingState.succeeded
      },
    )
    builder.addCase(checkExitFeedBackForm.fulfilled, (state, action) => {
      state.checkExitFeedBackFormTypes = action.payload
      state.isLoading = ApiLoadingState.succeeded
    })
    builder.addCase(
      getEmployeeSeparationFormThunk.rejected,
      (state, action) => {
        state.isLoading = ApiLoadingState.failed
        state.error = action.payload as ValidationError
      },
    )
  },
})

const SeparationThunks = {
  getEmployeeSeparationFormThunk,
  checkExitFeedBackForm,
}

const resignationListDetails = (state: RootState): CheckExitFeedBackFormTypes =>
  state.Separation.checkExitFeedBackFormTypes

const separationSelectors = {
  resignationListDetails,
}
export const SeparationServices = {
  ...SeparationThunks,
  actions: separationSlice.actions,
  selectors: separationSelectors,
}

const SeparationReducer = separationSlice.reducer
export default SeparationReducer
